import { Box, CircularProgress, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { apiVariable } from "../../../api/apiVariable";
import { formatDate } from "../../../helpers/formatingFunctions";

const fetchRentPayments = async (
  token: string | null | undefined,
  assetId: string,
  assetType: string,
) => {
  const { data } = await axios.get(
    `${apiVariable}/rentPayments/${assetId}/${assetType}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return data;
};

interface PaymentHistoriesProps {
  assetId: string;
  token: string | null | undefined;
  assetType: "truck" | "trailer";
}

const PaymentHistories = ({
  assetId,
  token,
  assetType,
}: PaymentHistoriesProps) => {
  const {
    data: rentPayments,
    isLoading: isLoadingRentPayments,
    isError: isErrorRentPayments,
    error: rentPaymentsError,
  } = useQuery({
    queryKey: ["rentPayments", assetId],
    queryFn: () => fetchRentPayments(token, assetId, assetType),
    enabled: !!assetId,
  });

  const rentPaymentsColumns = [
    {
      field: "paymentDate",
      headerName: "Payment Date",
      width: 200,
      valueFormatter: (params: any) => (params ? formatDate(params) : ""),
    },
    {
      field: "paymentAmount",
      headerName: "Amount",
      width: 150,
      valueFormatter: (params: any) =>
        params ? `$${Number(params).toFixed(2)}` : "",
    },
    { field: "paymentMethod", headerName: "Payment Method", width: 200 },
    { field: "payee", headerName: "Payee", width: 200 },
    { field: "createdBy", headerName: "Created By", width: 200 },
  ];

  if (isLoadingRentPayments) {
    return <CircularProgress />;
  }

  if (isErrorRentPayments) {
    return (
      <Typography color="error">
        Error: {(rentPaymentsError as Error).message}
      </Typography>
    );
  }

  return (
    <Box sx={{ height: 400, width: { xs: "100%", sm: "80%" }, minWidth: 0 }}>
      <DataGrid
        rows={rentPayments || []}
        columns={rentPaymentsColumns}
        getRowId={(row) => row.id}
      />
    </Box>
  );
};

export default PaymentHistories;
